
import { callEndpoint, callEndpointWithPayload } from '../baseApi'

export const GetCustomCTA = async (id,idToken) => {
    return await callEndpoint(`${process.env.REACT_APP_API}/call_to_actions/${id}`, 'GET', idToken)
  }

export const UpdateCustomCTA = async (idToken, payload, id) => {
    return await callEndpointWithPayload(`${process.env.REACT_APP_API}/call_to_actions/${id}`, 'PATCH', idToken, payload)
}

export const AddCustomCTA = async (idToken, payload, appId) => {
    return await callEndpointWithPayload(`${process.env.REACT_APP_API}/apps/${appId}/call_to_actions/`, 'POST', idToken, payload)
}

export const DeleteCustomCTA = async (idToken, id) => {
    return await callEndpoint(`${process.env.REACT_APP_API}/call_to_actions/${id}`, 'DELETE', idToken)
}